import { ReactNode } from 'react';

export const AUTH_ROUTES = {
  LOGIN: '/auth/login',
  SIGN_UP: '/auth/sign-up',
  AUTH_CALLBACK: '/auth/callback',
  CONFIRM_EMAIL: '/auth/confirm-email',
  ONBOARDING: '/auth/onboarding',
  ONBOARDING_AVATAR_GENERATION: '/auth/avatar-generation',
  FORGOT_PASSWORD: '/auth/forgot-password',
  SET_PASSWORD: '/auth/set-password',
};

export const APP_ROUTES = {
  HOME: '/',
  SHOWS: '/shows',
  SHOWS_INITIALIZATION: '/shows/initialization',
  SHOW_LIVE: '/show',
  SHOW_RECORDED: '/recorded-show',
  SHOW_SCHEDULED: '/scheduled-show',
  SEARCH: '/search',
  INBOX: '/inbox',
  PROFILE: '/profile',
  CHANNELS: '/channels',
  FOLLOWING: '/following',
  VERIFY_ACCOUNT: '/verify-account',
  FOOTBALL_SCORES: '/football-scores',
  SUBSCRIPTIONS: '/subscriptions',
};

export enum AccessLevel {
  PUBLIC = 'public',
  AUTHENTICATED = 'authenticated',
  GUEST = 'guest',
  ONBOARDING = 'onboarding',
  PASSWORD_RESET = 'password_reset',
  AVATAR_FLOW = 'avatar_flow',
}

export type RouteGuardProps = {
  children: ReactNode;
  accessLevel: AccessLevel;
  fallbackPath?: string;
};
